/**
 * Set up routing for all Sponsor views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import sponsor views
import SingleSponsor from './views/SingleSponsor.js.jsx';
import SponsorList from './views/SponsorList.js.jsx';
import SponsorsStudiesList from './views/SponsorsStudiesList.js.jsx';

class SponsorRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute login={true} exact path="/sponsors" component={SponsorList} />
        <YTRoute login={true} exact path="/sponsors/:sponsorId" component={SingleSponsor} />
        <YTRoute login={true} exact path="/sponsors/:sponsorId/my-studies" component={SponsorsStudiesList} />
      </Switch>
    )
  }
}

export default SponsorRouter;



// WEBPACK FOOTER //
// modules/sponsor/SponsorRouter.js.jsx